import { render, staticRenderFns } from "./PaginatedCreationHistoryList.vue?vue&type=template&id=e5a488f2"
import script from "./PaginatedCreationHistoryList.vue?vue&type=script&lang=ts"
export * from "./PaginatedCreationHistoryList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports